import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import apiService from "../../../../../service/Api";

interface LeaderboardUser {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  venue_count: number;
  average_venue_score: number;
}

interface LeaderboardResponse {
  leaderboard: LeaderboardUser[];
  total_participants: number;
}

const VenueLeaderboard: React.FC = () => {
  const [data, setData] = useState<LeaderboardResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        setLoading(true);
        const res = await apiService.get<LeaderboardResponse>(
          "/api/management/dashboard/venues-leaderboard/"
        );
        setData(res.data);
      } catch (err: any) {
        setError(err?.message || "Failed to fetch leaderboard.");
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 0 }}>
      <Typography variant="h5" fontWeight={700} mb={3}>
        Venue Leaderboard
      </Typography>

      {loading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">{error}</Typography>}

      <Box sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          CREATOR
        </Typography>
        <Typography variant="subtitle2" color="text.secondary">
          VENUES
        </Typography>
      </Box>

      <List>
        {data?.leaderboard?.map((entry, index) => {
          const fullName =
            entry.first_name || entry.last_name
              ? `${entry.first_name} ${entry.last_name}`.trim()
              : entry.email;

          return (
            <Box key={entry.id}>
              <ListItem
                sx={{
                  bgcolor: "#f7f7f7",
                  borderRadius: 2,
                  my: 1,
                  px: 2,
                  py: 1.5,
                }}
                secondaryAction={
                  <Typography fontWeight={600}>{entry.venue_count}</Typography>
                }
              >
                <Typography variant="body1" fontWeight={700} sx={{ width: 30 }}>
                  {index + 1}.
                </Typography>

                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "grey.400" }}>
                    {fullName.charAt(0)}
                  </Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={fullName}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItem>
            </Box>
          );
        })}
      </List>
    </Card>
  );
};

export default VenueLeaderboard;
